import { render, staticRenderFns } from "./ResultadoIsfAcs.vue?vue&type=template&id=0ca9f75c&scoped=true"
import script from "./ResultadoIsfAcs.vue?vue&type=script&lang=js"
export * from "./ResultadoIsfAcs.vue?vue&type=script&lang=js"
import style0 from "./ResultadoIsfAcs.vue?vue&type=style&index=0&id=0ca9f75c&prod&lang=css"
import style1 from "./ResultadoIsfAcs.vue?vue&type=style&index=1&id=0ca9f75c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca9f75c",
  null
  
)

export default component.exports